import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const BankRevenueToRequestedCreditRatioProcessPayloadSchema = z.object({
    ratio: z.number().optional(),
    averageBankRevenue: z.number().optional(),
    requestedAmount: z.number().optional(),
});

export class BankRevenueToRequestedCreditRatioProcessPayload extends FromSchema(BankRevenueToRequestedCreditRatioProcessPayloadSchema) {
    ratio?: number;
    averageBankRevenue?: number;
    requestedAmount?: number;
}
